"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDataMessage = exports.setDisplaySegmentIds = exports.setAudienceViews = exports.setPermissions = exports.setTagIds = exports.setIsDataPage = exports.SET_CURRENT_DATA_PAGE = exports.SET_DATA_MESSAGE = exports.SET_DISPLAY_SEGMENT_IDS = exports.SET_DEFAULT_AUDIENCE_VIEWS = exports.SET_PERMISSIONS = exports.SET_TAG_IDS = exports.SET_IS_DATA_PAGE = void 0;
var SET_IS_DATA_PAGE = 'SET_IS_DATA_PAGE';
exports.SET_IS_DATA_PAGE = SET_IS_DATA_PAGE;
var SET_TAG_IDS = 'SET_TAG_IDS';
exports.SET_TAG_IDS = SET_TAG_IDS;
var SET_PERMISSIONS = 'SET_PERMISSIONS';
exports.SET_PERMISSIONS = SET_PERMISSIONS;
var SET_DEFAULT_AUDIENCE_VIEWS = 'SET_DEFAULT_AUDIENCE_VIEWS';
exports.SET_DEFAULT_AUDIENCE_VIEWS = SET_DEFAULT_AUDIENCE_VIEWS;
var SET_DISPLAY_SEGMENT_IDS = 'SET_DISPLAY_SEGMENT_IDS';
exports.SET_DISPLAY_SEGMENT_IDS = SET_DISPLAY_SEGMENT_IDS;
var SET_DATA_MESSAGE = 'SET_DATA_MESSAGE';
exports.SET_DATA_MESSAGE = SET_DATA_MESSAGE;
var SET_CURRENT_DATA_PAGE = 'SET_CURRENT_DATA_PAGE';
exports.SET_CURRENT_DATA_PAGE = SET_CURRENT_DATA_PAGE;

var setIsDataPage = function setIsDataPage(value) {
  return {
    type: SET_IS_DATA_PAGE,
    payload: value
  };
};

exports.setIsDataPage = setIsDataPage;

var setTagIds = function setTagIds(value) {
  return {
    type: SET_TAG_IDS,
    payload: value
  };
};

exports.setTagIds = setTagIds;

var setPermissions = function setPermissions(value) {
  return {
    type: SET_PERMISSIONS,
    payload: value
  };
};

exports.setPermissions = setPermissions;

var setAudienceViews = function setAudienceViews(values) {
  return {
    type: SET_DEFAULT_AUDIENCE_VIEWS,
    payload: values
  };
};

exports.setAudienceViews = setAudienceViews;

var setDisplaySegmentIds = function setDisplaySegmentIds(value) {
  return {
    type: SET_DISPLAY_SEGMENT_IDS,
    payload: value
  };
};

exports.setDisplaySegmentIds = setDisplaySegmentIds;

var setDataMessage = function setDataMessage(value) {
  return {
    type: SET_DATA_MESSAGE,
    payload: value
  };
};

exports.setDataMessage = setDataMessage;